import React, { useEffect, useState } from 'react';

import { Main } from '@klp/layout';

import { useGetLeverandorConfluenceContentQuery } from '../services/rtkApi';
import {
    Heading,
    Block,
    Tooltip,
    Typography,
    ActionButton,
    ActionLink,
} from '@klp/design';
import { Box, Grid, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { Loader } from '@klp/design/Loader';
import ReactHtmlParser from 'react-html-parser';
import { LeverandorProsessDocumentationId, LeverandorRoutes } from '../config';
import { useHistory } from 'react-router-dom';
import { sanitizeHtmlContent } from '@forvalter/utils/sanitizeHtmlContent';

export default function LeverandorProsessDefinisjonDokumentasjon() {
    const [zIndex, setZIndex] = useState(0);
    const history = useHistory();
    const useStyles = makeStyles((theme) => ({
        datePicker: {
            width: '150px',
        },
        errorContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexDirection: 'column',
        },
        errorContent: {
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: theme.spacing(1),
        },
        actionButtons: {
            position: 'sticky',
            top: '10px',
            backgroundColor: 'white',
            zIndex: zIndex,
            width: 'fit-content',
        },
    }));

    const classes = useStyles();

    const {
        data: confluenceContentData,
        isError: confluenceContentError,
        isLoading: confluenceContentLoading,
        isFetching: confluenceContentFetching,
    } = useGetLeverandorConfluenceContentQuery({
        id: LeverandorProsessDocumentationId(),
    });

    const handleScroll = () => {
        if (window.scrollY > 135) {
            setZIndex(1500);
        } else {
            setZIndex(0);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <Main>
            <Main.Breadcrumbs>
                <Main.Crumb
                    id="leverandorSchema"
                    label="breadcrumbs.leverandor.schema"
                    href={LeverandorRoutes.leverandorSchema()}
                />
                <Main.Crumb
                    id="leverandorDokumentasjon"
                    label="breadcrumbs.leverandor.documentation"
                    href={LeverandorRoutes.leverandorSchemaDocumentationUrl()}
                />
            </Main.Breadcrumbs>
            <Main.Navigation>
                <ActionLink
                    actionType="linkBack"
                    translation="leverandor.backButton"
                    href={LeverandorRoutes.leverandorSchema()}
                />
            </Main.Navigation>
            {!confluenceContentError ? (
                <Loader
                    isLoading={
                        confluenceContentLoading || confluenceContentFetching
                    }
                >
                    {confluenceContentData?.body && (
                        <>
                            <Heading
                                klpHeadingLevel="ONE"
                                klpColor="dark"
                                translation="leverandor.processDefinition.documentationTitle"
                            />
                            <Block
                                className={classes.actionButtons}
                                paddingTop="tiny"
                                paddingBottom="tiny"
                            >
                                <Grid
                                    container={true}
                                    direction="row"
                                    justifyContent="flex-start"
                                    spacing={1}
                                >
                                    <Grid item={true}>
                                        <Block>
                                            <Tooltip
                                                translation="leverandor.processDefinition.read"
                                                title=""
                                            >
                                                <IconButton
                                                    color="inherit"
                                                    aria-label="Open external confluence view"
                                                    onClick={() =>
                                                        window.open(
                                                            confluenceContentData?.readLink,
                                                            '_blank',
                                                        )
                                                    }
                                                >
                                                    <Illustration
                                                        icon={IconName.EXTERNAL}
                                                    />
                                                </IconButton>
                                            </Tooltip>
                                        </Block>
                                    </Grid>
                                    <Grid item={true}>
                                        <Tooltip
                                            translation="leverandor.processDefinition.iconTitle"
                                            title=""
                                        >
                                            <IconButton
                                                color="inherit"
                                                aria-label="Open detailed diagram view"
                                                onClick={() =>
                                                    history.push(
                                                        LeverandorRoutes.processdefinitionDiagram(),
                                                    )
                                                }
                                            >
                                                <Illustration
                                                    icon={IconName.CIRCLE_INFO}
                                                />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            </Block>
                            <Block paddingTop="tiny">
                                {ReactHtmlParser(
                                    sanitizeHtmlContent(
                                        confluenceContentData.body,
                                    ),
                                )}
                            </Block>
                        </>
                    )}
                </Loader>
            ) : (
                <Block marginTop="fat" className={classes.errorContainer}>
                    <Box className={classes.errorContent}>
                        <Typography
                            variant="h5"
                            translation="general.error.message"
                        />

                        <ActionButton
                            actionType="button"
                            translation="general.reload"
                            onClick={() => window.location.reload()}
                        />
                    </Box>
                </Block>
            )}
        </Main>
    );
}
